import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import { Spinner } from '../../../../common/index.jsx';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const SearchTypeTable = ({ searchTypes, customSettings }) => {
  const { t } = useTranslation();

  const dataGridColumns = useMemo(
    () => [
      {
        title: t('Vyhľadávací typ'),
        dataIndex: 'name',
      },
    ],
    [t],
  );

  if (!searchTypes) {
    return <Spinner />;
  }
  return (
    <>
      <DataGrid
        rowKey={(searchType) => searchType.id}
        columns={dataGridColumns}
        permissionsBasic={'search-admin'}
        uniqueTableId={'search-type-table'}
        customSettings={customSettings}
        dataSource={searchTypes || []}
      />
    </>
  );
};

export default SearchTypeTable;
